<template>
    <div class="app-height w-full flex flex-col bg-gray-F0F0F0 tracking-normal text-base text-black">
        <print-layout
            v-if="isPrintMode"
        />
        <intro-modal />
        <div class="w-full flex-grow flex flex-col lg:flex-row lg:justify-between">
            <product-header class="lg:cz-hidden" />

            <product-renderer-wrapper
                :show-fullscreen-button="true"
                class="relative flex-grow"
                :class="{
                    'lg:w-screen z-[200]': isFullscreen,
                    'lg:w-[calc(100%-492px)] z-[10]': !isFullscreen,
                }"
            />

            <!-- <debug-panel /> -->

            <step-options-wrapper
                class="order-1 flex-shrink-0 lg:order-none lg:w-[492px] transition-transform duration-300 ease-out"
            />

        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import ProductHeader from './ProductHeader.vue';
    import ProductRendererWrapper from './ProductRendererWrapper.vue';
    import StepOptionsWrapper from './StepOptionsWrapper.vue';
    import PrintLayout from './buttons/PrintLayout.vue';
    import IntroModal from './IntroModal.vue';
    // import DebugPanel from './DebugPanel.vue';

    export default {
        mixins: [allStores],

        components: {
            ProductHeader,
            ProductRendererWrapper,
            StepOptionsWrapper,
            PrintLayout,
            IntroModal,
            // DebugPanel,
        },

        data() {
            return {};
        },

        computed: {
            isFullscreen() {
                return this.appStore.isFullscreen;
            },

            isPrintMode() {
                return this.appStore.isPrintMode;
            },

            specialMessage() {
                return this.customizerStore.specialMessage;
            },
        },

        methods: {
            copyToClipboard(selection) {
                navigator.clipboard.writeText(JSON.stringify(selection));
            },
        },
    };
</script>
